import styled, { keyframes, css } from 'styled-components';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const firstPlaceRaysAnimation = keyframes`
  0% {
    background:
      radial-gradient(circle at 20% 20%, rgba(255, 215, 0, 0.3) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle at 80% 30%, rgba(255, 215, 0, 0.25) 0%, rgba(255, 255, 255, 0) 25%),
      radial-gradient(circle at 40% 90%, rgba(255, 215, 0, 0.28) 0%, rgba(255, 255, 255, 0) 22%),
      radial-gradient(circle at 90% 70%, rgba(255, 215, 0, 0.3) 0%, rgba(255, 255, 255, 0) 28%),
      radial-gradient(circle at 10% 60%, rgba(255, 215, 0, 0.2) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle, rgba(255, 215, 0, 0.1) 0%, rgba(255, 255, 255, 0) 70%);
    box-shadow: 0 0 10px 3px rgba(255, 215, 0, 0.2 );
  }
  33% {
    background:
      radial-gradient(circle at 30% 30%, rgba(255, 215, 0, 0.28) 0%, rgba(255, 255, 255, 0) 25%),
      radial-gradient(circle at 70% 20%, rgba(255, 215, 0, 0.3) 0%, rgba(255, 255, 255, 0) 28%),
      radial-gradient(circle at 20% 80%, rgba(255, 215, 0, 0.25) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle at 80% 80%, rgba(255, 215, 0, 0.28) 0%, rgba(255, 255, 255, 0) 25%),
      radial-gradient(circle at 50% 40%, rgba(255, 215, 0, 0.2) 0%, rgba(255, 255, 255, 0) 18%),
      radial-gradient(circle, rgba(255, 215, 0, 0.15) 0%, rgba(255, 255, 255, 0) 70%);
    box-shadow: 0 0 12px 4px rgba(255, 215, 0, 0.25);
  }
  66% {
    background:
      radial-gradient(circle at 60% 10%, rgba(255, 215, 0, 0.3) 0%, rgba(255, 255, 255, 0) 28%),
      radial-gradient(circle at 15% 40%, rgba(255, 215, 0, 0.25) 0%, rgba(255, 255, 255, 0) 22%),
      radial-gradient(circle at 75% 60%, rgba(255, 215, 0, 0.28) 0%, rgba(255, 255, 255, 0) 25%),
      radial-gradient(circle at 35% 75%, rgba(255, 215, 0, 0.3) 0%, rgba(255, 255, 255, 0) 28%),
      radial-gradient(circle at 85% 25%, rgba(255, 215, 0, 0.2) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle, rgba(255, 215, 0, 0.12) 0%, rgba(255, 255, 255, 0) 70%);
    box-shadow: 0 0 15px 5px rgba(255, 215, 0, 0.2);
  }
  100% {
    background:
      radial-gradient(circle at 20% 20%, rgba(255, 215, 0, 0.3) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle at 80% 30%, rgba(255, 215, 0, 0.25) 0%, rgba(255, 255, 255, 0) 25%),
      radial-gradient(circle at 40% 90%, rgba(255, 215, 0, 0.28) 0%, rgba(255, 255, 255, 0) 22%),
      radial-gradient(circle at 90% 70%, rgba(255, 215, 0, 0.3) 0%, rgba(255, 255, 255, 0) 28%),
      radial-gradient(circle at 10% 60%, rgba(255, 215, 0, 0.2) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle, rgba(255, 215, 0, 0.1) 0%, rgba(255, 255, 255, 0) 70%);
    box-shadow: 0 0 10px 3px rgba(255, 215, 0, 0.2);
  }
`;

const pulseAnimation = keyframes`
  0% {
    background:
      radial-gradient(circle at 25% 15%, rgba(33, 150, 243, 0.18) 0%, rgba(255, 255, 255, 0) 18%),
      radial-gradient(circle at 85% 25%, rgba(33, 150, 243, 0.15) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle at 50% 90%, rgba(33, 150, 243, 0.18) 0%, rgba(255, 255, 255, 0) 22%),
      radial-gradient(circle at 15% 65%, rgba(33, 150, 243, 0.18) 0%, rgba(255, 255, 255, 0) 16%),
      radial-gradient(circle at 90% 80%, rgba(33, 150, 243, 0.15) 0%, rgba(255, 255, 255, 0) 18%),
      radial-gradient(circle, rgba(33, 150, 243, 0.08) 0%, rgba(255, 255, 255, 0) 70%);
    box-shadow: 0 0 8px 2px rgba(33, 150, 243, 0.15);
  }
  50% {
    background:
      radial-gradient(circle at 35% 25%, rgba(33, 150, 243, 0.18) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle at 75% 35%, rgba(33, 150, 243, 0.15) 0%, rgba(255, 255, 255, 0) 22%),
      radial-gradient(circle at 20% 80%, rgba(33, 150, 243, 0.18) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle at 65% 10%, rgba(33, 150, 243, 0.18) 0%, rgba(255, 255, 255, 0) 18%),
      radial-gradient(circle at 80% 70%, rgba(33, 150, 243, 0.15) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle, rgba(33, 150, 243, 0.1) 0%, rgba(255, 255, 255, 0) 70%);
    box-shadow: 0 0 10px 3px rgba(33, 150, 243, 0.2);
  }
  100% {
    background:
      radial-gradient(circle at 25% 15%, rgba(33, 150, 243, 0.18) 0%, rgba(255, 255, 255, 0) 18%),
      radial-gradient(circle at 85% 25%, rgba(33, 150, 243, 0.15) 0%, rgba(255, 255, 255, 0) 20%),
      radial-gradient(circle at 50% 90%, rgba(33, 150, 243, 0.18) 0%, rgba(255, 255, 255, 0) 22%),
      radial-gradient(circle at 15% 65%, rgba(33, 150, 243, 0.18) 0%, rgba(255, 255, 255, 0) 16%),
      radial-gradient(circle at 90% 80%, rgba(33, 150, 243, 0.15) 0%, rgba(255, 255, 255, 0) 18%),
      radial-gradient(circle, rgba(33, 150, 243, 0.08) 0%, rgba(255, 255, 255, 0) 70%);
    box-shadow: 0 0 8px 2px rgba(33, 150, 243, 0.15);
  }
`;

export const Container = styled.div`
  padding: 2.5rem 3.5rem;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 2rem;
  h1 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 2rem;
    color: #1e88e5;
    margin-left: 0.5rem;
  }
`;

export const Dashboard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-top: 1px solid #e2e2e2;

  @media (max-width: 768px) {
    height: auto;
    padding: 1rem;
  }
`;

export const FilterButton = styled.ul`
  display: flex;
  list-style: none;
  padding: 0 0.5rem;
  border: 1px solid #e2e2e2;
  border-radius: 0.44rem;
  margin-top: 1.2rem;

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 6rem;
    border-right: 1px solid #e2e2e2;
    cursor: pointer;
    transition: background-color 0.3s;

    &:first-child {
      border-left: 1px solid #e2e2e2;
    }

    button {
      background: transparent;
      border: none;
      padding: 0.5rem 1rem;
      width: 100%;
      height: 100%;
      cursor: pointer;
      font-size: 0.9rem;
      color: #323232;
      transition: font-weight 0.2s;
    }

    &:hover {
      background-color: #ffe8c8;
    }

    &.active {
      background-color: #ffe0b2;

      button {
        font-weight: bold;
        border-right: 1.5px solid #ff6d00;
        border-left: 1.5px solid #ff6d00;
        color: #323232;
      }
    }
  }
`;

export const TopUsers = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 4rem;
  @media (max-width: 768px) {
    padding: 1rem;
    width: 100%;
  }
`;

export const PartyRanking = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  &.hidden-podium {
    opacity: 0;
    transform: translateY(50px);
  }

  &.animate-podium {
    animation: ${slideUp} 0.7s ease-out forwards;
  }

  &.animate-delay-1 {
    animation-delay: 0.2s;
  }

  &.animate-delay-2 {
    animation-delay: 0.4s;
  }
`;

export const Avatar = styled.div<{
  $color: string;
  $fisrtPlace?: boolean;
  $isLoggedUser?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;

  > img {
    width: 6.66rem;
    height: 6.66rem;
    padding: 0.2rem;
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid ${props => props.$color || '#ff9800'};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    ${props =>
      props.$isLoggedUser &&
      css`
        animation: ${pulseAnimation} 4s infinite;
        transition: all 0.3s ease;
        &:hover {
          transform: scale(1.05);
        }
      `}

    ${props =>
      props.$fisrtPlace &&
      props.$isLoggedUser &&
      css`
        animation: ${firstPlaceRaysAnimation} 4s infinite;
        transition: all 0.3s ease;
        &:hover {
          transform: scale(1.05);
        }
      `}
  }
  position: relative;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0.5rem 0.5rem;

  h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.2rem;
    color: #323232;
  }

  p {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.9rem;
    color: #757575;
  }
`;

export const Podium = styled.div<{
  $isFirstPlace?: boolean;
  $isLoggedUser?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  ${props =>
    props.$isLoggedUser &&
    css`
      svg {
        animation: ${shineAnimation} 3s infinite;
      }
    `}
`;

export const Points = styled.div`
  position: absolute;
  top: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'RedHatDisplay-Bold';
  font-size: 1rem;
  color: #323232;
  margin-bottom: 0.5rem;
`;

export const RankingTableUsers = styled.div`
  margin-top: 2rem;
  width: 80%;
`;

export const RankingTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 2rem;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
`;

export const TableHeader = styled.thead`
  background-color: #f5f5f5;

  th {
    padding: 1rem;
    text-align: left;
    font-family: 'RedHatDisplay-Bold';
    color: #323232;
  }
`;

export const TableBody = styled.tbody`
  tr {
    border-bottom: 1px solid #eee;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f9f9f9;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  td {
    padding: 1rem;
    font-family: 'RedHatDisplay-Regular';
    color: #323232;
    font-size: 0.9rem;
  }
`;

export const Position = styled.div<{ $position: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  color: ${({ $position }) => ($position <= 10 ? '#323232' : '#757575')};
  font-family: 'RedHatDisplay-Bold';
  font-size: 1rem;
`;

export const UserCell = styled.td`
  display: flex;
  align-items: center;
  gap: 1rem;

  img {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    object-fit: cover;
  }

  div {
    display: flex;
    flex-direction: column;

    h3 {
      margin: 0;
      font-family: 'RedHatDisplay-Bold';
      font-size: 0.9rem;
      color: #323232;
    }

    p {
      margin: 0;
      font-family: 'RedHatDisplay-Regular';
      font-size: 0.8rem;
      color: #757575;
    }
  }
`;

export const PointsCell = styled.td`
  font-family: 'RedHatDisplay-Bold';
  color: #ff9800;
  text-align: right;
`;

// Animação de brilho para o ícone de primeiro lugar
const shineAnimation = keyframes`
  0% {
    filter: drop-shadow(0 0 0 rgba(255, 215, 0, 0));
  }
  50% {
    filter: drop-shadow(0 0 5px rgba(255, 215, 0, 0.8));
  }
  100% {
    filter: drop-shadow(0 0 0 rgba(255, 215, 0, 0));
  }
`;

export const Crown = styled.div`
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1.8rem;
  color: gold;
  z-index: 10;
`;

export const WinnerBadge = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  background: linear-gradient(45deg, #ffd700, #ffa500);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
  border: 2px solid white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 5;
`;
